// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__Vkm8Q","preview":"Item_preview__1z7R0","category":"Item_category__3ldQB","title":"Item_title__2Y5mF","counter":"Item_counter__p7qrP"};